import Map from 'pages/Map';
import React, { useEffect } from 'react';
import Header from '../Header/Header';
import Loader from 'components/_old/atom/Loader';
import { useLocation } from 'react-router-dom';
import { initGA, sendPageView } from '../../../../analytics';
function Container(props) {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    sendPageView(location.pathname + location.search);
  }, [location]);
  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <Map />
    </div>
  );
}

export default Container;
